import "./reaction-list.scss";
import api from "api";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router";
import { ReactionListType, ReactionListRequestType, ClientContactType, ReactionListRecipientType } from "types";
import { toast } from "react-toastify";
import { Redirect } from 'react-router-dom';
import ViewLogs from "./view-logs";

import KanbanBoard from "./kanban-board";

function ReactionList() {
  const params: any = useParams();
  const history = useHistory();
  const [reactionList, setReactionList] = useState<ReactionListType | null>(null);
  const [editable, setEditable] = useState(false);
  const [showAddKeywordModal, setShowAddKeywordModal] = useState(false);
  const [showAddRecipientModal, setShowAddRecipientModal] = useState(false);
  const [keywordValue, setKeywordValue] = useState("");
  const [keywordType, setKeywordType] = useState(1);
  const [clientContacts, setClientContacts] = useState<ClientContactType[]>([]);
  const [newRecipient, setNewRecipient] = useState<ReactionListRecipientType | null>();
  const [activeWordBinLogs, setActiveWordBinLogs] = useState<any>(false);
  const [activeWordBinId, setActiveWordBinId] = useState<number>(1);
  const [activeViewWorkflow, setActiveViewWorkflow] = useState<any>(false);

  const onIntervalChange = (id: string) => {
    setReactionList({
      ...reactionList!,
      NotificationInterval: id,
    });
  };

  const onUpdate = useCallback(async () => {
    await api.reactionLists.update({ ...reactionList } as unknown as ReactionListRequestType)
      .then(() => {
        toast.success(`Reaction List Updated`); 
        setEditable(false);
        setShowAddKeywordModal(false);
        setShowAddRecipientModal(false);
        return;
      }).catch(err => {
        toast.error(err.toString());
      });
  }, [reactionList]);

  const onDelete = useCallback(async () => {
    await api.reactionLists.delete(params.reactionListId);
    history.goBack();
  }, [params.reactionListId, history]);

  const handleAddKeywordModal = (show: boolean) => {
    setShowAddKeywordModal(show);
  };

  const handleAddRecipientModal = (show: boolean) => {
    setShowAddRecipientModal(show);
  };

  const handleAddKeyword = () => {
    if (keywordValue !== "") {
      setReactionList({
        ...reactionList!,
        Keywords: [...reactionList!.Keywords, { Value: keywordValue, OperatorId: keywordType }],
      });
    }
  };

  const handleRemoveRecipient = (e: number) => {
    setReactionList({ ...reactionList!, Recipients: reactionList!.Recipients.filter((x) => x.ContactId !== e) });
  };

  const handleRemoveKeyword = (e: string) => {
    setReactionList({ ...reactionList!, Keywords: reactionList!.Keywords.filter((x) => x.Value !== e) });
  };

  const getClientContacts = useCallback(async () => {
    const data: ClientContactType[] = await api.clientContact.getAll(params.clientId);
    setClientContacts(data);
  }, [params.clientId]);

  const handleAddRecipient = () => {
    setReactionList({
      ...reactionList!,
      Recipients: [...reactionList!.Recipients, newRecipient!],
    });
    setNewRecipient(null);
    <Redirect to={`/client/${params.clientId}/project/${params.projectId}/reaction-lists`} />
  };

  const onGetReactionList = useCallback(async () => {
    const data = await api.reactionLists.get(params.reactionListId);
    setReactionList(data);
  }, [params.reactionListId]);

  const handleWordBinRecipientTypeId = (id: number) => {
    return (
      {
        1: "Alert Contact",
        2: "Popup Contact",
        3: "Response Contact",
      }[id] || ""
    );
  };

  const handleOperatorId = (id: number) => {
    return (
      {
        1: "AND",
        2: "OR",
        3: "NOT",
      }[id] || ""
    );
  };

  const activateWordBinLog = () => {
    setActiveWordBinLogs(true);

  }

  const handleSelectContact = (id: number) => {
    const contact = clientContacts.find((x) => x.Id === id);
    setNewRecipient({
      Cellphone: contact!.Phone,
      ContactId: contact!.Id,
      Email: contact!.Email,
      Name: contact!.Name,
      Surname: contact!.Surname,
      WordBinRecipientTypeId: 0,
    });
  };

  useEffect(() => {
    onGetReactionList();
    getClientContacts();
  }, [onGetReactionList]);

  return (
    <>
      {!activeViewWorkflow &&
        <>
          <div className="reaction-list">
            <div className="left">
              <div className="top-split">
                <div>
                  <h5>Reaction List</h5>
                </div>
                <div className="j-right">
                  <button className="view-logs" onClick={() => setActiveViewWorkflow(true)}>View Workflow</button>
                  <button className="view-logs" onClick={activateWordBinLog}>View Logs</button>
                </div>
              </div>
              {/* <button id="btn-view-logs" onClick={() => { }}>View Logs</button>
                  <button id="btn-view-workflow" onClick={() => { }}>View Workflow</button> */}
              <p className="heading"> Details & Recipients</p>

              <div className="left">
                <p className="heading">Name</p>
                <input id="name" disabled={!editable} value={reactionList?.Description} onChange={(e) => setReactionList({ ...reactionList!, Description: e.currentTarget.value })}></input>
              </div>

              <div className="right">
                <p className="heading">Notify Me</p>
                <select onChange={(e) => onIntervalChange(e.currentTarget.value)} value={reactionList?.NotificationInterval} id="notify" disabled={!editable}>
                  <option value="0">Immediate</option>
                  <option value="5">Every 5 minutes</option>
                  <option value="10">Every 10 minutes</option>
                  <option value="20">Every 20 minutes</option>
                  <option value="30">Every 30 minutes</option>
                  <option value="60">Every Hour</option>
                  <option value="360">Every Six Hours</option>
                  <option value="720">Every Twelve Hours</option>
                  <option value="1440">Once a day</option>
                </select>
              </div>

              {/* <div className="right">
                      <p className="heading">Language</p>
                      <p id="language">{reactionList?.LanguageId}</p>
                  </div> */}

              <div className="left">
                <p className="heading">Sentiment</p>
                <select defaultValue="0" value={reactionList?.SentimentId} id="sentiment" disabled={!editable}>
                  <option value="0">None</option>
                  <option value="1">Neutral</option>
                  <option value="2">Positive</option>
                  <option value="3">Negative</option>
                </select>
              </div>
              <br />
              <div className="left" id="div-start-date">
                <p className="heading">Start Date</p>
                <input disabled={!editable} type="date" id="start-date" value={moment(reactionList?.StartDate).format("YYYY-MM-DD")}
                  onChange={(e) => setReactionList({ ...reactionList!, StartDate: moment(e.currentTarget.value).format("YYYY-MM-DD") })}
                ></input>
              </div>

              <div className="right" id="div-end-date">
                <p className="heading">End Date</p>
                <input disabled={!editable} type="date" id="end-date" value={moment(reactionList?.StopDate).format("YYYY-MM-DD")}
                  onChange={(e) => setReactionList({ ...reactionList!, StopDate: moment(e.currentTarget.value).format("YYYY-MM-DD") })}
                ></input>
              </div>

              <div id="div-recipients">
                <p className="heading">Recipients</p>
                <div id="recipients">
                  {!reactionList?.Recipients.length ? (
                    <i style={{ display: "block", textAlign: "center", width: "100%" }}>No recipients added</i>
                  ) : (
                    reactionList?.Recipients.map((x, i) => (
                      <div className="recipient" data-id={x.ContactId} data-type-id={x.WordBinRecipientTypeId} key={i}>
                        <p className="type">{handleWordBinRecipientTypeId(x.WordBinRecipientTypeId)}</p>
                        <p className="value">{x.Name + " " + x.Surname + " (" + x.Email + ")"}</p>
                        {editable ? <i onClick={(e) => handleRemoveRecipient(x.ContactId)} className="fal fa-times"></i> : <></>}
                      </div>
                    ))
                  )}
                </div>

                {editable && !showAddRecipientModal ? (
                  <button id="btn-add-keyword" onClick={() => handleAddRecipientModal(true)}>
                    Add Recipient
                  </button>
                ) : (
                  <></>
                )}

                {showAddRecipientModal ? (
                  <>
                    <div className="input-group" id="add-keyword-div">
                      <div className="left">
                        <p className="heading">Recipient</p>
                        <select value={newRecipient?.ContactId || ""} onChange={(e) => handleSelectContact(parseInt(e.currentTarget.value))}>
                          <option value="" disabled selected>
                            Select Contact
                          </option>
                          {clientContacts
                            .filter((x) => !reactionList!.Recipients.map((r) => r.ContactId).includes(x.Id))
                            .map((x) => (
                              <option value={x.Id} key={x.Id}>
                                {x.Name} {x.Surname}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="right">
                        <p className="heading">Recipient Type</p>
                        <select value={newRecipient?.WordBinRecipientTypeId || 0} onChange={(e) => setNewRecipient({ ...newRecipient!, WordBinRecipientTypeId: parseInt(e.currentTarget.value) })}>
                          <option value="0" disabled selected>
                            Select Type
                          </option>
                          <option value="1">Alert Contact</option>
                          <option value="2">Popup Contact</option>
                          <option value="3">Response Contact</option>
                        </select>
                      </div>
                    </div>
                    <div className="button-group">
                      <button onClick={() => setShowAddRecipientModal(false)}>Cancel</button>
                      <button onClick={handleAddRecipient}>Save</button>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="right">
              <p className="heading">Keywords</p>
              <div id="keywords">
                {!reactionList?.Keywords.length ? (
                  <i style={{ display: "block", textAlign: "center", width: "100%" }}>No keywords added</i>
                ) : (
                  reactionList?.Keywords.map((x, i) => (
                    <div className="keyword" key={i}>
                      <p className="type" data-id={x.OperatorId}>
                        {handleOperatorId(x.OperatorId)}
                      </p>
                      <p className="value">{x.Value}</p>
                      {editable ? <i onClick={(e) => handleRemoveKeyword(x.Value)} className="fal fa-times"></i> : <></>}
                    </div>
                  ))
                )}
              </div>

              {editable && !showAddKeywordModal ? (
                <button id="btn-add-keyword" onClick={() => handleAddKeywordModal(true)}>
                  Add Keyword
                </button>
              ) : (
                <></>
              )}

              {showAddKeywordModal ? (
                <>
                  <div className="input-group" id="add-keyword-div">
                    <div className="left">
                      <p className="heading">Keyword</p>
                      <input onChange={(e) => setKeywordValue(e.currentTarget.value)} type="text" id="keyword" placeholder="Keyword" />
                    </div>
                    <div className="right">
                      <p className="heading">Keyword Type</p>
                      <select onChange={(e) => setKeywordType(parseInt(e.currentTarget.value))} id="keyword-type">
                        <option value="1">AND</option>
                        <option value="2">OR</option>
                        <option value="3">NOT</option>
                      </select>
                    </div>
                  </div>
                  <div className="button-group">
                    <button onClick={() => setShowAddKeywordModal(false)}>Cancel</button>
                    <button onClick={handleAddKeyword}>Save</button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="foot">
            {!editable ? (
              <></>
            ) : (
              <button
                id="btn-cancel-word-bin"
                onClick={() => {
                  setEditable(false);
                  setShowAddKeywordModal(false);
                }}
              >
                Cancel
              </button>
            )}
            <button id="btn-delete-word-bin" onClick={onDelete}>
              Delete
            </button>
            {!editable ? (
              <button id="btn-save-word-bin" onClick={() => setEditable(true)}>
                <i className="fal fa-pencil"></i> Edit
              </button>
            ) : (
              <button id="btn-save-word-bin" onClick={onUpdate}>
                <i className="fal fa-save"></i> Save
              </button>
            )}
          </div>
        </>}
      {activeWordBinLogs && <ViewLogs setActiveWordBinLogs={setActiveWordBinLogs} />}
      {/*activeViewWorkflow && <ViewWorkFlow setActiveViewWorkflow={setActiveViewWorkflow} wordBinId={params.reactionListId} startDate={reactionList?.StartDate} endDate={reactionList?.StopDate}/>*/}
      {activeViewWorkflow && <KanbanBoard wordBinId={params.reactionListId} deactivateWorkflow={setActiveViewWorkflow} />}
    </>
  );
}

export default ReactionList;
